import "../styles/contact.css";

const Contact = () => {
  return (
    <div className="contact-container contact-slide-in">
      <div className="contact-email">
        <p className="contact-text">Want to connect?</p>

        <a className="contact-email-link" href="mailto:kt@stayclassy.ai">
          kt@stayclassy.ai
        </a>
      </div>
    </div>
  );
};

export default Contact;
